module.exports = __webpack_public_path__ + "static/media/ph.dfa513c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ph.svg
// module id = 222
// module chunks = 0